import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import type { AuthContextValue } from './types';

/**
 * Hook to access the auth context
 */
export function useFirebaseAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useFirebaseAuth must be used within an AuthProvider');
  }

  return context;
}
